@if (chartOptions) {
  <highcharts-chart
    class="highcharts-chart-bullet"
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    [(update)]="updateFlag"
    >
  </highcharts-chart>
}
